var map;
var markers = [];
var infoWindows = [];

google.maps.event.addDomListener( window, 'load', initMap );

function initMap(){
    map = new google.maps.Map(document.getElementById('map'), {
        center: {
            // 以下の緯度経度を置換 var markerに同様の緯度経度があるため
            lat: 35.666343,
            lng: 139.369890
        },
        zoom: 16,
        mapTypeControl: false,
        scrollwheel: false,
        streetViewControl: false
    });
    var marker = new google.maps.Marker({
        position: new google.maps.LatLng(35.666343, 139.369890),
        map: map,
        icon: '../images/location/pin/pin_bukken.png'
    });
    // サンプルのため「menu0」、最初に表示する地図の名前に変更
    setMarker('shopping');
}

$('[data-map-area]').on('click', function(){
    setMarker($(this).data('map-area'));
    return false;
});

$('[data-map]').on('click', function(){
    var target = parseInt($(this).attr('href').slice(7));
    console.log(target);
    for (var i = 0; i < infoWindows.length; i++) {
        infoWindows[i].close();
    }
    infoWindows[target].open(markers[target].getMap(), markers[target]);
    map.panTo(markers[target].getPosition());
    return false;
});

function setMarker(type){
    for (var i = 0; i < markers.length; i++) {
        markers[i].setMap(null);
    }
    markers = [];
    infoWindows = [];
    var data = mapData[type];
    for (var i = 0; i < data.length; i++) {
        var num = i + 1;
        // pinNoを二桁にする
        var pinNo = ('00' + num).slice(-2);
        var marker = new google.maps.Marker({
            position: new google.maps.LatLng(data[i]['lat'], data[i]['lng']),
            map: map,
            // iconを編集しない場合はデフォルトです
            // ピンを画像にする場合
            // icon: '../images/location/pin/pin.png'
            // 全て項目のピンが同じ場合
            // icon: '../images/location/pin/pin_' + pinNo + '.png'
            // 項目ごとにピンの色を変える場合
            icon: '../images/location/pin/pin_' + type + pinNo + '.png'
        });
        var infoWindow = new google.maps.InfoWindow({ // 吹き出しの追加
            content: '<div class="u-text-bold">' + data[i]['title'] + '</div>' // 吹き出しに表示する内容
        });
        markers.push(marker);
        infoWindows.push(infoWindow);

        openInfoWindow(marker, infoWindow);
    }
}

function openInfoWindow(marker, infoWindow){
    google.maps.event.addListener(marker, 'click', function (event) {
        for (var i = 0; i < infoWindows.length; i++) {
            infoWindows[i].close();
        }
        infoWindow.open(marker.getMap(), marker);
        map.panTo(marker.getPosition());
    });
}


var mapData = {
    'shopping': [
        {
            title: 'ファミリーマート 日野バイパス店',
            lat:35.665378021758215,
            lng:139.37155866985827
        },
        {
            title: 'コープみらい コープ高倉店',
            lat:35.665141479979866,
            lng:139.36905124375295
        },
        {
            title: 'コジマ×ビックカメラ 八王子高倉店',
            lat:35.665083188242875,
            lng:139.3691397566505
        },
        {
            title: 'サンドラッグ 八王子高倉店',
            lat:35.664858124058064,
            lng:139.36722822139606
        },
        {
            title: 'スーパーアルプス 高倉店',
            lat:35.66390403928798,
            lng:139.367332776604
        },
        {
            title: 'オーケー 北八王子店',
            lat:35.66655080283227,
            lng:139.36444498195587
        },
        {
            title: 'トゥモロープラザ',
            lat:35.66580684726163,
            lng:139.3780666312179
        },
        {
            title: 'ミニストップ 多摩平3丁目店',
            lat:35.66285308214068,
            lng:139.37651992569528
        },
        {
            title: 'イオンモール多摩平の森',
            lat:35.66205629014708,
            lng:139.38062656748122
        },
    ],
    'parks': [
        {
            title: 'ぞうさん公園',
            lat:35.666706246407344,
            lng:139.3691924206213
        },
        {
            title: '新田公園',
            lat:35.66641752685751,
            lng:139.36832386842931
        },
        {
            title: '多摩平第９公園',
            lat:35.66558938906215,
            lng:139.37398362938276
        },
        {
            title: '高倉緑地',
            lat:35.669693,
            lng:139.370359
        },
        {
            title: '旭が丘北公園',
            lat:35.66346589508171,
            lng:139.37119354773307
        },
        {
            title: '高倉公園',
            lat:35.66865333658409,
            lng:139.3655890859329
        },
        {
            title: '多摩平第８公園',
            lat:35.66389460978605,
            lng:139.37603502323105
        },
        {
            title: '多摩平第1公園',
            lat:35.666512365711796,
            lng:139.37970813731718
        },
        {
            title: '黒川清流公園',
            lat:35.6664416994216,
            lng:139.38682031772615 }
    ],
    'medical': [
        {
            title: '八王子ひがし整形外科',
            lat:35.66581625032448,
            lng:139.37108306051385
        },
        {
            title: 'おがわ歯科医院',
            lat:35.665543,
            lng:139.371162
        },
        {
            title: 'いわさレディースクリニック',
            lat:35.665686966959086,
            lng:139.3687785801399
        },
        {
            title: '高倉町歯科クリニック',
            lat:35.66518194704878,
            lng:139.36914447511694
        },
        {
            title: '多摩平の森の病院',
            lat:35.66537270119961,
            lng:139.37711490362258
        },
        {
            title: '日野市立病院',
            lat:35.66690063662313,
            lng:139.378465269264
        },
        {
            title: '日野市休日準夜診療所',
            lat:35.66548997863321,
            lng:139.3774417704874
        },
        {
            title: '関根クリニック',
            lat:35.662887764952295,
            lng:139.37705144271027
        },
        {
            title: 'うちの耳鼻咽喉科クリニック',
            lat:35.66303377062064,
            lng:139.37708362921848
        },
        {
            title: '東海大学医学部付属八王子病院',
            lat:35.673713,
            lng:139.35703
        }
    ],
    'culture': [
        {
            title: 'フットサルクラブ東京八王子コート',
            lat:35.666803,
            lng:139.37101
        },
        {
            title: 'スポーツクラブ アクトスWill_G 八王子',
            lat:35.664544,
            lng:139.369352
        },
        {
            title: 'エニタイムフィットネス 八王子高倉',
            lat:35.665265,
            lng:139.369968
        },
        {
            title: 'トムスポーツアカデミーGYM24',
            lat:35.665537,
            lng:139.377946
        },
        {
            title: 'COCOGOLF イオンモール多摩平の森店',
            lat:35.66244512701682,
            lng:139.3815933649647
        },
        {
            title: '日野市立多摩平図書館',
            lat:35.66329168931369,
            lng:139.38144610606903
        },
        {
            title: 'オリンパスミュージアム',
            lat:35.66706984705451,
            lng:139.3587298594249
        },
        {
            title: 'ひの煉瓦ホール（日野市民会館）',
            lat:35.670290029485955,
            lng:139.39575526607226
        },
        {
            title: '新選組のふるさと歴史館',
            lat:35.673348147642905,
            lng:139.396517085203
        }
    ],
    'education': [
        {
            title: 'バディスポーツ幼児園 八王子東',
            lat:35.666796762688435,
            lng:139.37098337685953
        },
        {
            title: '敬愛高倉保育園',
            lat:35.665685,
            lng:139.369006
        },
        {
            title: 'ぽかぽか保育園 高倉園',
            lat:35.664519,
            lng:139.369602
        },
        {
            title: '東京都立大学 日野キャンパス',
            lat:35.66158902392021,
            lng:139.3664833189492
        },
        {
            title: '東京都立八王子東高等学校',
            lat:35.6618912101643,
            lng:139.36469743637144
        },
        {
            title: '八王子市立石川保育園',
            lat:35.67125380460544,
            lng:139.36133262017285
        },
        {
            title: '認定こども園ぽかぽか保育園 大和田園',
            lat:35.664091,
            lng:139.351179
        },
        {
            title: '八王子市立高倉小学校（通学区）',
            lat:35.66235851021011,
            lng:139.36577952386023
        },
        {
            title: '八王子市立第一中学校（通学区）',
            lat:35.669974916865364,
            lng:139.36172211098034
        }
    ],
    'public': [
        {
            title: '八王子高倉郵便局',
            lat:35.667691,
            lng:139.369321
        },
        {
            title: '多摩信用金庫高倉支店',
            lat:35.665009,
            lng:139.367921
        },
        {
            title: '三井住友銀行 イオンモール多摩平の森店',
            lat:35.66202420307852,
            lng:139.3809075115917
        },
        {
            title: 'きらぼし銀行 豊田支店',
            lat:35.661676,
            lng:139.379571
        },
        {
            title: 'みずほ銀行 日野支店',
            lat:35.66068573239489,
            lng:139.38030255208437
        },
        {
            title: '八王子警察署北八王子交番',
            lat:35.669468,
            lng:139.36001
        },
        {
            title: '八王子市役所石川出張所',
            lat:35.680748631341,
            lng:139.36627506466633
        },
        {
            title: '八王子消防署',
            lat:35.655715356479085,
            lng:139.32644856246537
        },
        {
            title: '八王子警察署',
            lat:35.66510112650856,
            lng:139.31697117723309
        }
    ],
    
    
}